import { useIntl, MessageDescriptor } from 'react-intl';

type MessageFormatPrimitiveValue = string | number | boolean | null | undefined;

type MessageFormatValues = Record<string, MessageFormatPrimitiveValue>;

export type IntlMessage = (
  message: MessageDescriptor,
  values?: MessageFormatValues | undefined
) => string;

export const useFormatMessage = () => {
  const intl = useIntl();

  return (message: MessageDescriptor, values?: MessageFormatValues) =>
    intl.formatMessage(message, values);
};
